module.exports = __webpack_public_path__ + "assets/yuanpan.5b17cad2.svg";